import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, mergeProps as _mergeProps, isRef as _isRef, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({
                'config-wrapper': true,
                show: true
            })
}
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex remote-video-list h-100 flex-wrap" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }

import {computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, watch} from "vue";
import WebRtcVideo from "./WebRtcVideo.vue";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";
import DraggableResizable from "~/cabinet/vue/interface/draggableResizable/DraggableResizable.vue";
import Random from "~/ts/library/Random";
import WebRtcUserDisplay from "~/core-ui/vue/chat/webrtc/WebRtcUserDisplay.vue";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {Intervals} from "~/ts/library/delay/Intervals";
import WebRtcMediaStream from "~/ts/library/webRtc/WebRtcMediaStream";
import Events from "~/ts/library/Events";

interface DeviceListInterface {
    audioinput: MediaDeviceInfo[],
    audiooutput: MediaDeviceInfo[],
    videoinput: MediaDeviceInfo[]
}


const __default__ = {
    name: "WebRtcCall"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    call: {},
    showScreenButton: { type: Boolean, default: true },
    showFullScreenButton: { type: Boolean, default: true },
    defaultLocalVideoWidth: { default: 250 },
    defaultLocalVideoHeight: { default: 150 }
  }, {
    "fullScreen": { type: Boolean, ...{
    default: false
} },
    "fullScreenModifiers": {},
  }),
  emits: ["update:fullScreen"],
  setup(__props: any) {

let props = __props;


let configDialog = ref<{
    visible: boolean,
    devices: DeviceListInterface
}>();
let container = ref<HTMLDivElement>();
let showControls = ref(!window.matchMedia("(hover: hover) and (pointer: fine)").matches);

let callStartedAudio = document.createElement("audio");
callStartedAudio.loop = true;
callStartedAudio.disableRemotePlayback = true;

let localVideoData = ref({
    left: 30,
    top: 30,
    width: props.defaultLocalVideoWidth,
    height: props.defaultLocalVideoHeight
});

let fullScreen = _useModel<boolean>(__props, "fullScreen");

let callAspectRatio = ref(1);
let instance = getCurrentInstance().proxy;

let videoInputCount = ref(0);


function computeAspectRatio() {
    let el: HTMLElement = instance.$el;
    if (el) {
        callAspectRatio.value = el.offsetWidth / el.offsetHeight;
    }
}

let isVerticalPlacementFor2Videos = computed(() => callAspectRatio.value < 1);

onMounted(computeAspectRatio);
addDisposableEvent(Intervals.setDisposable(computeAspectRatio, 1000));

callStartedAudio.src = `${props.call.getStaticServer()}/cabinet/assets/operatorApplication/sounds/callStarted.mp3`;

function pauseAudio() {
    try {
        callStartedAudio.pause();
        callStartedAudio.load();
    } catch (e) {

    }
}

onBeforeUnmount(() => {
    pauseAudio();
})

let isCallStartedAudioMustPlay = computed(() => {
    let pairs = props.call.getCallData()?.users
        .filter(user => !!user.pair)
        .map(user => user.pair);
    let isWaitingForInitializationCount = pairs
        .filter(pair => pair.status?.isWaitingForInitialization)
        .length;
    return isWaitingForInitializationCount == pairs.length;
});


watch(isCallStartedAudioMustPlay, value => {
    if (value) {
        callStartedAudio.currentTime = 0;
        callStartedAudio.play();
    } else {
        pauseAudio();
    }
}, {immediate: true});


let localStream = computed<MediaStream>(() => {
    return props.call.getRtcPeerConnections()[0]?.getLocalStream();
});

let remoteVideos = computed<MediaStream[]>(() => {
    return props.call
        .getRtcPeerConnections()
        .map(item => item.getRemoteStream())
        .filter(item => !!item);
});

let remoteVideosKey = computed(() => {
    if (remoteVideos.value.length || true) {
        return Random.uid();
    }
    return "";
});

let aspectRatio = ref(16 / 9);

addDisposableEvent(Intervals.setDisposable(() => {
    if (localStream.value) {
        let result = localStream.value.getVideoTracks()[0]?.getSettings()?.aspectRatio;
        if (result) {
            aspectRatio.value = result;
        }
    }
}, 500));


let videoWidth = computed(() => {
    let count = remoteUsers.value?.length;
    if (count > 1) {
        if (count == 2 && isVerticalPlacementFor2Videos.value) {
            return '100%';
        }
        return '50%';
    }
    return '100%';
});

let videoHeight = computed(() => {
    let count = remoteUsers.value?.length;
    if (count > 2 || (count == 2 && isVerticalPlacementFor2Videos.value)) {
        return '50%';
    }
    return '100%';
});

let remoteUsers = computed(() => {
    return props.call.getCallData()?.users.filter(user => !user.isYou);
});

addDisposableEvent(Intervals.setDisposable(() => enumerateDevice(), 5000));
enumerateDevice();


async function enumerateDevice() {
    if (!videoInputCount.value) {
        videoInputCount.value = (await WebRtcMediaStream.getVideoInputDevices(props.call)).length;
    }
}


function toggleFullScreen() {
    let newValue = !fullScreen.value;
    fullScreen.value = newValue;
    if (newValue) {
        container.value.requestFullscreen();
    } else {
        document.exitFullscreen();
    }
}

async function showConfigDialog() {
    configDialog.value = {
        visible: true,
        devices: null
    };
    let devices: Partial<DeviceListInterface> = {
        audioinput: [],
        audiooutput: [],
        videoinput: []
    };
    let kinds: MediaDeviceKind[] = ["audioinput", "audiooutput"];
    if (props.call.isUseVideo()) {
        kinds.push("videoinput");
    }
    for (let device of (await WebRtcMediaStream.getDevices(props.call, kinds, true))) {
        devices[device.kind].push(device);
    }
    configDialog.value.devices = devices as any as DeviceListInterface;
}

addDisposableEvent(Events.addEventListener("fullscreenchange", document, function () {
    if (!document.fullscreenElement) {
        fullScreen.value = false;
    }
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'call-container': true, fullscreen: _unref(fullScreen)}),
    ref_key: "container",
    ref: container,
    onMousedown: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
    onMousemove: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
    onMouseup: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
    onPointerdown: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
    onPointermove: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
    onPointerup: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
    onTouchstartPassive: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
    onTouchendPassive: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
    onTouchmovePassive: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_unref(configDialog)?.visible && __props.call.webRtcMediaStream)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              (!_unref(configDialog).devices)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Подождите, идет получение списка устройств..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (__props.call.isUseMicrophone())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mb-2" }, "Микрофон:", -1)),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.call.webRtcMediaStream.audioInputDeviceId) = $event))
                            }, [
                              _cache[26] || (_cache[26] = _createElementVNode("option", {
                                value: "",
                                disabled: "",
                                selected: "",
                                hidden: ""
                              }, "По умолчанию", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configDialog).devices.audioinput, (device) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: device.deviceId
                                }, _toDisplayString(device.label), 9, _hoisted_6))
                              }), 256))
                            ], 512), [
                              [_vModelSelect, __props.call.webRtcMediaStream.audioInputDeviceId]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.call.isUseVideo() && !__props.call.isMobile())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mb-2" }, "Камера:", -1)),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.call.webRtcMediaStream.videoInputDeviceId) = $event))
                            }, [
                              _cache[28] || (_cache[28] = _createElementVNode("option", {
                                value: "",
                                disabled: "",
                                selected: "",
                                hidden: ""
                              }, "По умолчанию", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configDialog).devices.videoinput, (device) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: device.deviceId
                                }, _toDisplayString(device.label), 9, _hoisted_8))
                              }), 256))
                            ], 512), [
                              [_vModelSelect, __props.call.webRtcMediaStream.videoInputDeviceId]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.call.webRtcMediaStream.isCanChangeAudioOutput())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mb-2" }, "Динамики:", -1)),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.call.webRtcMediaStream.audioOutputDeviceId) = $event))
                            }, [
                              _cache[30] || (_cache[30] = _createElementVNode("option", {
                                value: "",
                                disabled: "",
                                selected: "",
                                hidden: ""
                              }, "По умолчанию", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configDialog).devices.audiooutput, (device) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: device.deviceId
                                }, _toDisplayString(device.label), 9, _hoisted_10))
                              }), 256))
                            ], 512), [
                              [_vModelSelect, __props.call.webRtcMediaStream.audioOutputDeviceId]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(configDialog).visible = false))
                }, [
                  _renderSlot(_ctx.$slots, "close-config-button"),
                  (!_ctx.$slots['close-config-button'])
                    ? (_openBlock(), _createElementBlock("button", _hoisted_11, " Закрыть "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "flex-fill" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remoteUsers), (user, key) => {
        return (_openBlock(), _createBlock(WebRtcUserDisplay, {
          key: key,
          user: user,
          call: __props.call,
          class: "video",
          style: _normalizeStyle({width: `${_unref(videoWidth)} !important`, height: `${_unref(videoHeight)} !important`}),
          onTouchend: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showControls) //@ts-ignore
 ? showControls.value = !_unref(showControls) : showControls = !_unref(showControls)))
        }, {
          avatar: _withCtx(({avatar}) => [
            _renderSlot(_ctx.$slots, "avatar", _mergeProps({ ref_for: true }, {avatar}))
          ]),
          noaudio: _withCtx(() => [
            _renderSlot(_ctx.$slots, "noaudio")
          ]),
          novideo: _withCtx(() => [
            _renderSlot(_ctx.$slots, "novideo")
          ]),
          _: 3
        }, 8, ["user", "call", "style"]))
      }), 128))
    ]),
    (_unref(localStream))
      ? (_openBlock(), _createBlock(DraggableResizable, {
          key: _unref(remoteVideosKey),
          class: "local-video",
          left: _unref(localVideoData).left,
          "onUpdate:left": _cache[5] || (_cache[5] = ($event: any) => ((_unref(localVideoData).left) = $event)),
          top: _unref(localVideoData).top,
          "onUpdate:top": _cache[6] || (_cache[6] = ($event: any) => ((_unref(localVideoData).top) = $event)),
          width: _unref(localVideoData).width,
          "onUpdate:width": _cache[7] || (_cache[7] = ($event: any) => ((_unref(localVideoData).width) = $event)),
          height: _unref(localVideoData).height,
          "onUpdate:height": _cache[8] || (_cache[8] = ($event: any) => ((_unref(localVideoData).height) = $event)),
          "max-width": 450,
          "max-height": 500,
          "min-height": 50,
          ratio: _unref(aspectRatio),
          "bound-to": _ctx.$el,
          "allow-out-of-bound": false
        }, {
          default: _withCtx(() => [
            _createVNode(WebRtcVideo, {
              stream: _unref(localStream),
              "audio-enabled": __props.call.isUseMicrophone(),
              "video-enabled": __props.call.isUseVideo() || __props.call.isShowScreen(),
              "web-rtc-media-stream": __props.call.webRtcMediaStream,
              "is-local": "",
              muted: "",
              class: "video"
            }, {
              noaudio: _withCtx(() => [
                _renderSlot(_ctx.$slots, "noaudio")
              ]),
              novideo: _withCtx(() => [
                _renderSlot(_ctx.$slots, "novideo")
              ]),
              _: 3
            }, 8, ["stream", "audio-enabled", "video-enabled", "web-rtc-media-stream"])
          ]),
          _: 3
        }, 8, ["left", "top", "width", "height", "ratio", "bound-to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({'controls-wrapper': true, show: _unref(showControls)})
    }, [
      _createElementVNode("div", {
        class: "controls",
        onMousedownCapture: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
        onPointerdownCapture: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("span", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (__props.call.hangUp()))
        }, [
          _renderSlot(_ctx.$slots, "hangup"),
          (!_ctx.$slots.hangup)
            ? (_openBlock(), _createElementBlock("button", _hoisted_13, " Stop "))
            : _createCommentVNode("", true)
        ]),
        (!__props.call.isMobile() || !__props.call.isUseMicrophone())
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (__props.call.toggleUseMicrophone(!__props.call.isUseMicrophone())))
            }, [
              _renderSlot(_ctx.$slots, "microphone", _normalizeProps(_guardReactiveProps({enabled: __props.call.isUseMicrophone()}))),
              (!_ctx.$slots.microphone)
                ? (_openBlock(), _createElementBlock("button", _hoisted_14, " Mic "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.call.isLocalVideoAvailable() && !__props.call.isShowScreen())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (__props.call.toggleUseVideo(!__props.call.isUseVideo())))
              }, [
                _renderSlot(_ctx.$slots, "camera", _normalizeProps(_guardReactiveProps({enabled: __props.call.isUseVideo()}))),
                (!_ctx.$slots.camera)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_15, " Cam "))
                  : _createCommentVNode("", true)
              ]),
              (__props.call.isUseVideo())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (__props.call.isCanRotateCamera())
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (__props.call.toggleFacingMode()))
                        }, [
                          _renderSlot(_ctx.$slots, "camera-rotate"),
                          (!_ctx.$slots['camera-rotate'])
                            ? (_openBlock(), _createElementBlock("button", _hoisted_16, " Rotate "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.call.isSelfieSegmentationAvailable())
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (__props.call.toggleSelfieSegmentation()))
                        }, [
                          _renderSlot(_ctx.$slots, "selfie-segmentation", _normalizeProps(_guardReactiveProps({enabled: __props.call.isUseSelfieSegmentation()}))),
                          (!_ctx.$slots['selfie-segmentation'])
                            ? (_openBlock(), _createElementBlock("button", _hoisted_17, " Blur "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (__props.call.webRtcMediaStream && (__props.call.isUseVideo() || __props.call.isUseMicrophone() || __props.call.webRtcMediaStream.isCanChangeAudioOutput()))
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              onClick: showConfigDialog
            }, [
              _renderSlot(_ctx.$slots, "config"),
              (!_ctx.$slots['config'])
                ? (_openBlock(), _createElementBlock("button", _hoisted_18, " Config "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.showScreenButton)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (__props.call.toggleShowScreen(!__props.call.isShowScreen())))
            }, [
              _renderSlot(_ctx.$slots, "desktop", _normalizeProps(_guardReactiveProps({enabled: __props.call.isShowScreen()}))),
              (!_ctx.$slots.desktop)
                ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Scr "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.showFullScreenButton)
          ? (_openBlock(), _createElementBlock("span", {
              key: 4,
              onClick: toggleFullScreen
            }, [
              _renderSlot(_ctx.$slots, "fullscreen", _normalizeProps(_guardReactiveProps({enabled: _unref(fullScreen)}))),
              (!_ctx.$slots.fullscreen)
                ? (_openBlock(), _createElementBlock("button", _hoisted_20, " Full "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "after-buttons")
      ], 32)
    ], 2)
  ], 34))
}
}

})